<template>
	<form :key="'PERSONAL_INFO'" :class="{ 'px-100-md': thirdPartyAuthStore.isSignupEnabled }" @submit.prevent>
		<BasePlaceHolder :placehold="isLoading" :line-count="4" :section-count="2">
			<h1 :class="isInTest ? 'heading-4' : 'heading-3'" data-test="email-title">What is your email address?</h1>
			<p class="text-color-content-secondary mt-50" :class="isInTest ? 'mb-150' : 'mb-200'">
				Tell us a bit about yourself -- we'll create your account and suggest the strategy that best fits
				your&nbsp;goals.
			</p>
			<label v-if="!isInTest" for="email" class="field__label" data-test="email-label"
				><span id="emaillabel">Email address</span></label
			>
			<LeadCaptureComponent class="mt-25" :form-config="leadCaptureFormConfig" />
		</BasePlaceHolder>
	</form>
</template>
<script setup lang="ts">
import { computed, ref } from 'vue';
import { EmailCaptureFields, LeadCaptureFormConfig } from 'types/layout/lead';
import { isMobileOS } from '@utils/client';
import LeadCaptureComponent from '@components/lead-capture/lead-capture-form.vue';
import MobileRedirectModal from '@components/modals/mobile-redirect-modal.vue';
import { useAppStore } from '@stores/app';
import { useRouter } from 'vue-router';
import { useSignupStore } from '@stores/signup';
import { useThirdPartyAuthStore } from '@stores/third-party-auth';

const signupStore = useSignupStore();

const router = useRouter();

const appStore = useAppStore();
const thirdPartyAuthStore = useThirdPartyAuthStore();

const isInTest = ref(false);

const leadCaptureFormConfig = computed(
	(): LeadCaptureFormConfig => ({
		buttonText: 'Continue',
		forceShowInput: true,
		fullWidth: true,
		buttonClass: isInTest.value ? 'button-primary lead-capture__button-primary width-100' : '',
		placeholder: isInTest.value ? 'Email address' : 'example@fundrise.com',
		redirectCallback: redirectAfterSubmit,
		signupFlowType: 'STANDARD'
	})
);

const isLoading = ref(true);

const isMobileDevice = computed((): boolean => {
	return isMobileOS();
});

async function redirectAfterSubmit(leadResponseData: EmailCaptureFields): Promise<void> {
	signupStore.emailCaptureFields = leadResponseData;
	const queryData: Record<string, string> = {};

	if (leadResponseData.newLead) {
		queryData.new_lead = String(leadResponseData.newLead);
	}
	if (leadResponseData.mixpanelId) {
		queryData.distinct_id = String(leadResponseData.mixpanelId);
	}

	if (isMobileDevice.value) {
		appStore.updateCurrentModal({
			modal: MobileRedirectModal,
			props: {
				continueLink: {
					text: 'No thanks, continue on mobile browser',
					router: 'checkout-password',
					query: queryData
				}
			}
		});
	} else {
		await router.push({
			name: 'checkout-password',
			query: queryData
		});
	}
}

async function setup() {
	try {
		isInTest.value = await signupStore.determineStreamlineSignupTestGroup();
	} catch {
	} finally {
		isLoading.value = false;
	}
}

setup();
</script>
